var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M12.2082 6.302V7.28638H8.94602L8.64036 9.44785C9.16736 9.00513 9.78396 8.88534 10.3004 8.88534C11.834 8.88534 12.6667 9.93742 12.6667 11.2551C12.6667 12.7135 11.6338 13.7499 10.0317 13.7499C8.68252 13.7499 7.65485 13.0156 7.33337 11.8176L8.35577 11.5103C8.58238 12.302 9.19898 12.776 10.0422 12.776C10.9855 12.776 11.5863 12.1822 11.5863 11.2916C11.5863 10.4947 11.1015 9.83845 10.1318 9.83845C9.52046 9.83845 8.97237 10.0833 8.61928 10.4583L7.60215 10.1145L8.12916 6.302H12.2082Z",
            fill: "#666666",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }